import { ZanLengthCalc } from "../../_modules/zan-length-calc"

document.addEventListener('DOMContentLoaded', () => {
    const _ = new ZanLengthCalc();
});
